(() => {
  const storageKey = 'hasbro-recently-viewed-products';

  const readProducts = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.handle) : [];
    } catch (error) {
      return [];
    }
  };

  const saveCurrentProduct = () => {
    const source = document.getElementById('HasbroCurrentProduct');
    if (!source) return;

    try {
      const current = JSON.parse(source.textContent);
      if (!current?.handle) return;
      const updated = [current, ...readProducts().filter((item) => item.handle !== current.handle)].slice(0, 8);
      window.localStorage.setItem(storageKey, JSON.stringify(updated));
    } catch (error) {
      // Browsing should continue normally when storage is unavailable.
    }
  };

  const createRecentCard = (product) => {
    const card = document.createElement('article');
    card.className = 'hasbro-recent-card';
    card.dataset.productHandle = product.handle;

    const mediaLink = document.createElement('a');
    mediaLink.className = 'hasbro-recent-card__image';
    mediaLink.href = product.url;
    mediaLink.setAttribute('aria-label', product.title);
    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      mediaLink.appendChild(image);
    }

    const body = document.createElement('div');
    body.className = 'hasbro-recent-card__body';
    const title = document.createElement('a');
    title.className = 'hasbro-recent-card__title';
    title.href = product.url;
    title.textContent = product.title;
    body.appendChild(title);

    if (product.type) {
      const type = document.createElement('p');
      type.textContent = product.type;
      body.appendChild(type);
    }

    const rating = Math.max(0, Math.min(5, Math.round(Number(product.rating) || 5)));
    const ratingRow = document.createElement('div');
    ratingRow.className = 'hasbro-recent-card__rating';
    ratingRow.setAttribute('aria-label', `Rated ${rating} out of 5`);
    ratingRow.textContent = `${'★'.repeat(rating)}${'☆'.repeat(5 - rating)}`;
    if (product.ratingCount) ratingRow.textContent += ` (${product.ratingCount})`;
    body.appendChild(ratingRow);

    const price = document.createElement('strong');
    price.textContent = product.price;
    body.appendChild(price);
    card.append(mediaLink, body);
    return card;
  };

  const renderRecentProducts = () => {
    const section = document.querySelector('[data-hasbro-recently-viewed]');
    const grid = section?.querySelector('[data-recent-products-grid]');
    if (!section || !grid) return;

    const products = readProducts();
    if (products.length) {
      grid.replaceChildren(...products.map(createRecentCard));
      section.dataset.usingHistory = 'true';
    }

    section.querySelector('[data-recent-prev]')?.addEventListener('click', () => {
      grid.scrollBy({ left: -grid.clientWidth * 0.8, behavior: 'smooth' });
    });
    section.querySelector('[data-recent-next]')?.addEventListener('click', () => {
      grid.scrollBy({ left: grid.clientWidth * 0.8, behavior: 'smooth' });
    });
  };

  const initialize = () => {
    saveCurrentProduct();
    renderRecentProducts();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
